var t={wrap:"styles_wrap__D3Qkx",img:"styles_img__EKVlI",title:"styles_title__Bee0I",text:"styles_text__fzLa0"};export{t as default};
